<template>
    <m-pageframe
        :title="title"
        :color="pageframe_color"
    >

        <v-container
            fluid
            style="padding-left: 30px; padding-right: 30px"
        >

            <v-text-field
                v-model="full_text"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="margin-bottom: 15px;"
                v-on:input="update"
                autocomplete="off"
            >
                <span
                    slot="append-outer"
                >
                    <v-menu 
                        bottom 
                        offset-y  
                    >
                    
                    <template v-slot:activator="{ on }">
                            
                        <v-icon 
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                            
                    </template>
                    
                    <v-list>

                        <v-list-item
                            v-on:click="onClickExport()"
                        >
                            <v-list-item-title>Export to Excel...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickManualOptInOut()"
                        >
                            <v-list-item-title>Manual opt in/out...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickImport()"
                        >
                            <v-list-item-title>Bulk Import Consent...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickAPIInstructions()"
                        >
                            <v-list-item-title>API Integration Instructions...</v-list-item-title>
                        </v-list-item>
                    
                    </v-list>
                    
                    </v-menu> 
                </span>
            </v-text-field>

            <m-create-bulk-opt-out-dialog
                ref="bulk-opt-out-dialog"
            />

            <v-data-table
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"

                hide-default-footer
                v-on:click:row="onClickRow"
            >

                <template v-slot:item.endpoint="{ item }">
                    {{$rc.pretty(item.endpoint,'endpoint')}}
                </template>

                <template v-slot:item.action="{ item }">
                    <v-menu
                        bottom
                        offset-y
                    >

                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-dots-vertical-circle-outline
                            </v-icon>
                        </template>

                        <v-list>
                            <v-list-item
                                v-on:click="onViewDetails(item.organization_id, item.endpoint)"
                            >
                                <v-list-item-title>View Details...</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-on:click="onClickCreateOptOutFromExisting(item)"
                            >
                                <v-list-item-title>Manually opt in/out...</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>

            </v-data-table>


            <m-icon-bar
                v-on:add="onClickCreateOptOut"
            />

            <m-create-bulk-opt-out-dialog
                ref="bulk-opt-out-dialog"
                v-on:upsert_bulk_opt_out="afterUpsertBulkOptOut($event)"
            />

            <m-dialog-bulk-import-dialog
                ref="bulk-import-dialog"
            />

        </v-container>

        <m-consent-register-api-instructions-dialog
            ref="consent-register-api-instructions-dialog"
        />
    </m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');
const E164 = require('@/js/E164.js');
const _ = require('lodash');

export default {

    data() {
        return {
            organization_name: null,
            full_text: '',
            results: [],

            headers: [
                { text: 'Name', value: 'full_name' },
                { text: 'Phone', value: 'endpoint' },
                { text: 'Conversational', value: 'conversational' },
                { text: 'Informational', value: 'informational' },
                { text: 'Promotional', value: 'promotional' },
                { text: 'Action', value: 'action', align: 'end' }
            ],

        }
    },

    created () {
        this.$event_bus.$on('update-pickup', this.doUpdate);

    },

    beforeDestroy () {
        this.$event_bus.$off('update-pickup',this.doUpdate);
    },

    mounted () {
        this.getOrganizationName();
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/consent/current-state',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'full_text' : this.full_text
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },
        

        prettyDateAndTime(time)
        {
            return Time.getISODate(time) + ' ' + Time.getPeriodClockTime(time);
        },

        prettyPrintPhoneNumber(endpoint) {
            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        getOrganizationName() {
            this.$rc.getOrganizationLabel(
                this.$route.params.organization_id,

                (label) => {
                    this.organization_name = label;
                }
            );
        },

        onClickCreateOptOutFromExisting(row_entry)
        {
            this.$refs['bulk-opt-out-dialog'].showDialog(
                this.$route.params.organization_id,
                row_entry.endpoint
            );
        },

        onClickCreateOptOut()
        {
            this.$refs['bulk-opt-out-dialog'].showDialog(
                this.$route.params.organization_id
            );
        },

        onClickRow(item)
        {
            this.onViewDetails(item.organization_id, item.endpoint, item.contact_label);
        },

        onViewDetails(organization_id, endpoint, contact_label)
        {
            this.$router.push({
                'name': 'view-consent-details',
                'params' : {
                    'organization_id' : organization_id,
                    'endpoint' : endpoint
                }
            }).catch(e=>{}); // swallow any exception
        },

        afterUpsertBulkOptOut(bulk_opt_out)
        {
            this.doUpdate();
        },
        
        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/bulk/opt-outs/export-current-state/:organization_id',
                    {
                        'organization_id' : this.$route.params.organization_id,
                    }
                );
        },

        onClickManualOptInOut(item)
        {
            this.$refs['bulk-opt-out-dialog'].showDialog(
                this.$route.params.organization_id,
                null,
                null
            );
        }, 

        onClickImport()
        {
            this.$refs['bulk-import-dialog'].showDialog();
        },

        onClickAPIInstructions()
        {
            this.$refs['consent-register-api-instructions-dialog'].showDialog();
        },
    },

    computed: {

        title() {
            if ( this.organization_name == null )
                return 'Consent Register';

            return this.organization_name + ' Consent Register';
        },

        pageframe_color() {
            if ( this.$route.params.organization_id !== this.$rc.$state.organization_id )
                return '#5D647C';
            else
                return '#F24653';
        }
    },

}
</script>

<style lang="scss" scoped>
</style>